// extracted by mini-css-extract-plugin
module.exports = {"outer":"outer___3NyGx","name":"name___3ndvX","value":"value___3qsRE"};